import { CompanyTypeEnum, CompanyTypeEnumFR, translateCompanyType } from './enums/CompanyTypeEnum';
import type { AddressModel, AddressModelFR } from './AddressModel';
import { translateAddressModel } from './AddressModel';

export type CompanyModelFR = {
	id: number;
	nomPremiereRevisionSlugified: string;
	nom: string;
	denominationSociale: string;
	immatriculationNum: string;
	immatriculationVille: string;
	isEnCoursImmatriculation: boolean;
	formeJuridique: CompanyTypeEnumFR;
	adresseFiscale: AddressModelFR;
	qualiteRepresentant: string;
	isPersonneMorale: boolean;
	isGereeParWiseed: boolean;
	hasCoRepresentant: boolean;
	qualiteCoRepresentant: string;
	isCoRepresentantPersonneMorale: boolean;
	societeRepresentanteName: string;
	societeCoRepresentanteName: string;
};

export type CompanyModel = {
	id: number;
	firstRevisionName: string;
	name: string;
	companyName: string;
	registrationNum: string;
	registrationCity: string;
	isRegistrationPending: boolean;
	legalStatus: CompanyTypeEnum;
	fiscalAddress: AddressModel;
	qualityRepresentative: string;
	isLegalEntity: boolean;
	isManagedByWiseed: boolean;
	hasCoRepresentative: boolean;
	qualityCoRepresentative: string;
	isCoRepresentativeLegalEntity: boolean;
	representedBy: string;
	coRepresentedBy: string;
};

export const translateCompany = (cm: CompanyModelFR): CompanyModel => {
	return {
		id: cm?.id,
		firstRevisionName: cm?.nomPremiereRevisionSlugified,
		name: cm?.nom,
		companyName: cm?.denominationSociale,
		registrationNum: cm?.immatriculationNum,
		registrationCity: cm?.immatriculationVille,
		isRegistrationPending: cm?.isEnCoursImmatriculation,
		legalStatus: cm && translateCompanyType(cm.formeJuridique),
		fiscalAddress: cm && translateAddressModel(cm.adresseFiscale),
		qualityRepresentative: cm?.qualiteRepresentant,
		isLegalEntity: cm?.isPersonneMorale,
		isManagedByWiseed: cm?.isGereeParWiseed,
		hasCoRepresentative: cm?.hasCoRepresentant,
		qualityCoRepresentative: cm?.qualiteCoRepresentant,
		isCoRepresentativeLegalEntity: cm?.isCoRepresentantPersonneMorale,
		representedBy: cm?.societeRepresentanteName,
		coRepresentedBy: cm?.societeCoRepresentanteName
	};
};
